import { useQuery, UseQueryResult } from "react-query"
import CarrotClient from "lib/carrot-api"
import Settings from "utils/CarrotConfig"
import ResponseError from "utils/ResponseError"
import { Employee } from "types/Employee"
import { Company } from "types/Company"
import { RetryConfig } from "utils/ErrorHandling"
const client = new CarrotClient(Settings.CARROT_BACKEND_URL)
const ENDPOINT = "GetEmployee"

type EmployeeDataType = { employee: Employee; company: Company }

const loadData = async (employeeId: string): Promise<EmployeeDataType> => {
  const employee = await client.getEmployee(employeeId)
  const company = await client.getCompany(employee.companyId)
  return { employee, company }
}

export default function useEmployee(employeeId: string): UseQueryResult<EmployeeDataType, ResponseError> {
  return useQuery<EmployeeDataType, ResponseError>([ENDPOINT, employeeId], () => loadData(employeeId), {
    ...RetryConfig
  })
}
